import { Component } from '@angular/core';
import { StringHelper } from '@clean-code/shared/common';
import { DataTableBaseComponent } from '@clean-code/shared/components/ui-data-table';

import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { type NormCubicMeter } from '@clean-code/models';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import {
  TableStateService,
  UiMatTableModule,
} from '@clean-code/shared/components/ui-mat-table';
import { PageContainerModule } from '@clean-code/shared/components/ui-page-container';
import { TranslocoModule } from '@jsverse/transloco';
import { NormCubicMeterService } from '../../services/norm-cubic-meter.service';

@Component({
    selector: 'backoffice-frontend-norm-cubic-meter-list',
    templateUrl: './norm-cubic-meter-list.component.html',
    imports: [
        CommonModule,
        TranslocoModule,
        UiMatTableModule,
        PageContainerModule,
        RouterModule,
        ActionButtonModule,
    ],
    providers: [TableStateService]
})
export class NormCubicMeterListComponent extends DataTableBaseComponent<NormCubicMeter> {
  public override navigateUrl = '/settings/norm-cubic-meters';

  public stringHelper = StringHelper;

  constructor(protected service: NormCubicMeterService) {
    super(service);
    this.defaultSort2 = [{ prop: 'year', dir: 'DESC' }];
  }
}
